import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setContainerRowsCols } from '../Reducers/Configurator/Actions';
import { getContainer } from '../Reducers/Configurator/Selectors';
import containerIcon from '../Resources/Images/icon_container.png';
import Typography from '@material-ui/core/Typography';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles(
  (theme) => ({
    gridContainer: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '60%',
      margin: '20px auto',
      [theme.breakpoints.down('sm')]: {
        width: '90%',
      },
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
    },
    cell: {
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      border: `2px solid transparent`,
      transition: 'opacity 0.2s ease, border-color 0.2s ease',
    },
    cellImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      display: 'block',
    },
    selected: {
      opacity: 1,
      borderColor: theme.palette.primary.main,
    },
    unselected: {
      opacity: 0.5,
    },
    hovered: {
      opacity: 1,
    },
  }),
  { name: 'ContainerRowSelection' }
);

export const ContainerRowSelection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const container = useSelector(getContainer);
  const selectedRows = container.rows || 1;
  const selectedCols = container.columns || 1;

  const [hoveredCell, setHoveredCell] = useState<{ row: number; col: number } | null>(null);

  const maxRows = 2;
  const maxCols = 8;

  const handleCellClick = (row: number, col: number) => {
    dispatch(setContainerRowsCols(row, col));
  };

  const handleCellHover = (row: number, col: number) => {
    setHoveredCell({ row, col });
  };

  const handleMouseLeave = () => {
    setHoveredCell(null);
  };

  const isCellSelected = (row: number, col: number) => {
    const effectiveRows = hoveredCell ? hoveredCell.row : selectedRows;
    const effectiveCols = hoveredCell ? hoveredCell.col : selectedCols;

    return row <= effectiveRows && col <= effectiveCols;
  };

  const getCellClassName = (row: number, col: number) => {
    const isSelected = isCellSelected(row, col);
    const isActuallySelected = row <= selectedRows && col <= selectedCols;

    if (isActuallySelected) {
      return `${classes.cell} ${classes.selected}`;
    }
    if (isSelected) {
      return `${classes.cell} ${classes.hovered}`;
    }
    return `${classes.cell} ${classes.unselected}`;
  };

  return (
    <div>
      <Typography>{t('containerRowSelection.selectContainerAmount')}</Typography>
      <div className={classes.gridContainer} onMouseLeave={handleMouseLeave}>
        {Array.from({ length: maxRows }, (_, rowIndex) => (
          <div key={rowIndex} className={classes.row}>
            {Array.from({ length: maxCols }, (_, colIndex) => (
              <div
                key={colIndex}
                className={getCellClassName(rowIndex + 1, colIndex + 1)}
                onClick={() => handleCellClick(rowIndex + 1, colIndex + 1)}
                onMouseEnter={() => handleCellHover(rowIndex + 1, colIndex + 1)}
              >
                <img src={containerIcon} alt="Container" className={classes.cellImage} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContainerRowSelection;
